import { AnalyticCategoryActions } from 'models';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { dynamicQuoteCancelledThunk, dynamicQuoteRequestedThunk } from 'state/dynamic/dynamicForm.thunks';
import { BookingType, QuoteType } from 'state/quotes/infos/infos.model';
import type { Thunk } from 'state/state.common';
import { staticQuoteCancelledThunk, staticQuoteRequestedThunk } from 'state/static/staticForm.thunks';
import { WorkspaceType } from 'state/workspaces/model';

import { quotesRemoved } from './quotes.actions';
import { regulationQuoteRemoved } from './regulations/regulation.actions';
import { hasRegulationOnQuote } from './regulations/regulation.selectors';

export function notUsedQuoteCleanedThunk(tabId: string, quoteId: string): Thunk<void> {
  return (dispatch, getState, { selectors: { canRemoveQuoteData } }) => {
    const state = getState();
    if (hasRegulationOnQuote(state, tabId, quoteId)) {
      dispatch(regulationQuoteRemoved(tabId, quoteId));
    }
    if (canRemoveQuoteData(state, { quoteId, removedTabId: tabId })) {
      dispatch(quotesRemoved(tabId, quoteId));
    }
  };
}

export function cancelQuoteByWorkspaceThunk(tabId: string, workspace: WorkspaceType): Thunk<void> {
  return dispatch => {
    switch (workspace) {
      case 'static':
        dispatch(staticQuoteCancelledThunk(tabId));
        break;
      case 'dynamic':
        dispatch(dynamicQuoteCancelledThunk(tabId));
        break;
      default:
        return;
    }
  };
}

const quoteTypeToTracking: Record<
  QuoteType,
  AnalyticCategoryActions['Primary market static' | 'Primary market dynamic']
> = {
  Indicative: 'Request for quote',
  AdvancedIndicative: 'Request for advanced indicative quote',
  Tradable: 'Request for tradable quote',
  AdvancedTradable: 'Request for advanced tradable quote',
  ExecOnly: 'Request for exec only quote',
  AdvancedExecOnly: 'Request for advanced exec only quote',
  Executable: 'Request for executable quote',
  AdvancedExecutable: 'Request for advanced executable quote',
  BookWithExecution: 'Request for book with execution',
  BookWithoutExecution: 'Request for book without execution',
};

export function quoteRequestedByWorkspaceThunk(
  tabId: string,
  quoteType: QuoteType | BookingType,
  workspace: WorkspaceType,
): Thunk<void> {
  return dispatch => {
    if (workspace === 'static') {
      logAnalytics.trackEvent('Primary market static', quoteTypeToTracking[quoteType]);
      dispatch(staticQuoteRequestedThunk(tabId, quoteType));
    } else {
      logAnalytics.trackEvent('Primary market dynamic', quoteTypeToTracking[quoteType]);
      dispatch(dynamicQuoteRequestedThunk(tabId, quoteType));
    }
  };
}
